import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';

import * as deploymentConfig from 'login-utils/deploymentConfig';

const actionColor = deploymentConfig.getOrganizationColors().action;

const spin = {
  '0%': {
    transform: 'rotate(0deg)',
  },
  '100%': {
    transform: 'rotate(360deg)',
  },
};

const styles = StyleSheet.create({
  spinnerWrapper: {
    display: 'inline-block',
    height: 50,
    position: 'relative',
    width: 50,
  },
  spinnerSection: {
    animation: '1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
    animationName: [spin],
    border: `5px solid ${actionColor}`,
    borderColor: `${actionColor} transparent transparent transparent`,
    borderRadius: '50%',
    boxSizing: 'border-box',
    display: 'block',
    height: 44,
    position: 'absolute',
    width: 44,

    ':nth-child(1)': {
      animationDelay: '-0.45s',
    },
    ':nth-child(2)': {
      animationDelay: '-0.3s',
    },
    ':nth-child(3)': {
      animationDelay: '-0.15s',
    },
  },
});

export default class LoadingSpinner extends React.PureComponent {
  render() {
    return (
      <div className={css(styles.spinnerWrapper)}>
        <div className={css(styles.spinnerSection)} />
        <div className={css(styles.spinnerSection)} />
        <div className={css(styles.spinnerSection)} />
      </div>
    );
  }
}
